<template>
  <section class="content">
    <header-com />
    <div class="topBg"></div>

    <div class="mainMsg">
      <div class="box">
        <div class="tabBox">
          <div v-for="(item,index) of tabArr" :key="index" :class="index==tabIndex?'tab tabActive':'tab'" @click="tabClick(index)">{{item}}</div>
        </div>
        <div v-if="couponList.length>0" class="couponBox">
          <div v-for="(item,index) of couponList[tabIndex].fixedActivityList" :key="index" class="myCoupon">
            <div :class="item.activityStatus==30||item.activityStatus==40?'leftText textGray':'leftText'">{{item.salesPromotionBos[0].promotionName}}</div>
            <div class="rightBox">
              <div :class="item.activityStatus==30||item.activityStatus==40?'word1 textGray':'word1'">{{item.activityName}}</div>
              <div :class="item.activityStatus==30||item.activityStatus==40?'word2 textGray':'word2'">{{item.activityDesc}}</div>
              <div class="rightBottomBox">
                <div v-if="item.validType == 10" class="time">有效期至<br>{{item.endTime.split(' ')[0]}}</div>
                <div v-if="item.validType == 20" class="time"><br>有效期{{item.validDays}}天</div>
                
                <div v-if="authIndex==tabIndex && (item.activityStatus==10 || !item.activityStatus)" class="getBtn" @click="getCoupon(item,item.id)">领取</div>
                <div v-if="authIndex!=tabIndex && (item.activityStatus==10 || !item.activityStatus)" class="getBtn bgGray">领取</div>

                <div v-if="item.activityStatus==20" class="getBtn" @click="toUse(item)">去使用</div>
                <div v-if="item.activityStatus==30" class="getBtn bgGray">已使用</div>
                <div v-if="item.activityStatus==40" class="getBtn bgGray">已过期</div>
              </div>
            </div>
          </div>
          <div v-if="tabIndex==0" class="taps">注：【新人礼】仅限未下单的新用户领取</div>
          <div v-if="tabIndex==1" class="taps">注：【答谢礼】仅限首次下单并结算后，用户可以领取</div>
          <div v-if="tabIndex==2" class="taps">注：【复购礼】仅限下单并结算后，订单数量≥2时，用户可以领取</div>
        </div>

      </div>

      <div class="ad" @click="$router.push({path:'/about'})"></div>

      <div class="ruleBox">
        如有疑问请致电400-052-0618<br/>
        活动解释权归包拯所有
      </div>

    </div>

    <div class="g-fixed-bottom">
      <div class="btmBtn" @click="$router.push({path:'/'})">返回首页</div>
    </div>

    <van-popup v-model="ewmPopup">
      <div class="myPopup">
        <img class="ewm" src="/images/home/couponPage_ewm.png"/>
        <img
          src="/images/home/newGift_close.png"
          @click="ewmPopup = false"
          class="close1"
        />
      </div>
    </van-popup>

    <van-popup v-model="ewmPopup2">
      <div class="myPopup">
        <img class="ewm" src="/images/home/couponPage_ewm2.png"/>
        <img
          src="/images/home/newGift_close.png"
          @click="ewmPopup2 = false"
          class="close1"
        />
      </div>
    </van-popup>
    
  </section>
</template>

<script>
import wxShare from "@/assets/js/wx.share"
import homeApi from "@/axios/home";
import { Toast } from 'vant';
export default {
  name: "couponPage",
  data() {
    return {
      tabArr:[],
      tabIndex: 0,
      authIndex: 0,
      couponList:[],
      id: this.$route.query.id,
      ewmPopup: false,
      ewmPopup2: false
    }
  },
  computed: {
    customerId(){
      return this.$store.state.customerId;
    }
  },
  mounted() {
    console.log('store===>',this.customerId)
    if(this.customerId) {
      this.getCouponList2()
      this.getCouponStep()
    } else {
      this.getCouponList1()
    }
    setTimeout(()=>{
      let shareBody = {
        title : '喂！来领新人礼',
        desc : '全周期呵护你的心爱之物。包包、鞋子、衣服等都能用！',
        link: window.location.href,
        imgUrl:'http://mi.baozheng.cc/images/home/coupon_share.png'
      }; 
      wxShare(shareBody);
    },100)
  },
  methods: {
    tabClick(index) {
      this.tabIndex = index
    },

    toUse(item) {
      this.$router.push({path:'/serviceDetail',query:{serviceId:item.curingServiceGoodsBos[0].id}})
    },

    getCoupon(item,id) {
      let params = {
        customerZoneActivityId: this.id,
        activityId: item.id
      }
      homeApi.getCoupon(params).then(res=>{
        Toast('领取成功！')
        setTimeout(()=>{
          // if(this.tabIndex === 0) {
          //   if(id === 382) {
          //     this.ewmPopup2 = true
          //   } else {
          //     this.ewmPopup = true
          //   }
          // }
          this.getCouponList2()
          this.getCouponStep()
        },1000)
      })
    },

    getCouponStep() {
      homeApi.getCouponStep().then(res=>{
        this.tabIndex = res
        this.authIndex = res
      })
    },

    getCouponList2() {
      homeApi.getCouponList2({id:this.id}).then(res=>{
        this.tabArr = JSON.parse(res.activityStep)
        let list = []
        if(res.stepZero) list.push(res.stepZero)
        if(res.stepOne) list.push(res.stepOne)
        if(res.stepTwo) list.push(res.stepTwo)
        this.couponList = list
      })
    },

    getCouponList1() {
      homeApi.getCouponList1({id:this.id}).then(res=>{
        this.tabArr = JSON.parse(res.activityStep)
        if(res.stepZero) this.couponList.push(res.stepZero)
        if(res.stepOne) this.couponList.push(res.stepOne)
        if(res.stepTwo) this.couponList.push(res.stepTwo)
      })
    }
  }
};
</script>

<style scoped lang="scss">
.van-popup {
  background: transparent;
}
.myPopup{
  width: 7.7rem;
  margin: 0 auto;
  .ewm{
    width: 100%;
    height: 100%;
  }
  .close1 {
      margin: 32px auto 0;
      display: block;
      width: 60px;
      height: 60px;
    }
}
.content{
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(to top, #D7FFFE, #BFDDDD);
  padding: 1.33rem 0 2rem;
  box-sizing: border-box;
  .ruleBox{
    font-size: 0.35rem;
    line-height: 0.54rem;
    margin-top: 0.2rem;
    text-align: center;
    color: rgba(58, 119, 134, 1);
  }
  .topBg{
    width: 100%;
    height: 8.48rem;
    background: url('/images/home/coupon_top_bg.png') no-repeat;
    background-size: contain;
  }
  .mainMsg{
    width: 100%;
    box-sizing: border-box;
    padding: 0 0.43rem;
  }
  .box{
    width: 100%;
    border-radius: 0.27rem;
    background-color: white;
    margin-top: -2rem;
    box-sizing: border-box;
    .tabBox{
      width: 100%;
      display: flex;
      flex-wrap: nowrap;
      .tab{
        width: 33.334%;
        height: 1.28rem;
        border-bottom: 0.06rem solid #ECECEC;
        font-size: 0.53rem;
        color: #9B9B9B;
        line-height: 1.28rem;
        text-align: center;
      }
      .tabActive{
        font-weight: 600;
        color: #FF2653;
        border-bottom: 0.06rem solid #FF2653;
      }
    }
    .couponBox{
      width: 100%;
      padding: 0.43rem 0.43rem 0.2rem;
      box-sizing: border-box;
      .taps{
        font-size: 0.29rem;
        font-weight: 400;
        color: #8E8E93;
        line-height: 0.43rem;
        text-align: center;
        margin: 0.2rem 0;
      }
      .myCoupon{
        width: 100%;
        height: 3.22rem;
        margin-bottom: 0.24rem;
        background: url('/images/home/coupon_myCoupon_bg.png') no-repeat;
        background-size: contain;
        display: flex;
        .leftText{
          width: 33.33%;
          height: 3.22rem;
          line-height: 3.22rem;
          text-align: center;
          color: #FF2653;
          font-size: 0.7rem;
          font-weight: 600;
        }
        .rightBox{
          width: 56%;
          height: 3.22rem;
          margin-left: 3%;
          box-sizing: border-box;
          padding-top: 0.48rem;
          .word1{
            font-weight: 500;
            font-size: 0.45rem;
            color: #4A4A4A;
            line-height: 0.64rem;
          }
          .word2{
            margin-top: 0.1rem;
            font-weight: 400;
            font-size: 0.35rem;
            height: 1rem;
            color: rgba(155, 155, 155, 1);
            line-height: 0.48rem;
          }
          .rightBottomBox{
            width: 100%;
            height: 0.64rem;
            display: flex;
            .time{
              width: 2.9rem;
              line-height: 0.32rem;
              color: #9B9B9B;
              font-size: 0.29rem;
              font-weight: 400;
            }
            .getBtn{
              width: 1.6rem;
              height: 0.64rem;
              background: #FF2351;
              border-radius: 0.4rem;
              color: white;
              font-size: 0.35rem;
              text-align: center;
              line-height: 0.64rem;
            }
          }
        }
      }
    }
  }
  .ad{
    width: 100%;
    height: 2.08rem;
    margin-top: 0.37rem;
    background: url('/images/home/coupon_ad_bg.png') no-repeat;
    background-size: contain;
  }
  .btmBtn{
    width: 9.15rem;
    height: 1.17rem;
    background: #FF2351;
    border-radius: 0.59rem;
    color: white;
    line-height: 1.17rem;
    font-size: 0.45rem;
    text-align: center;
  }
}

.bgGray{
  background: #9B9B9B !important;
}
.textGray{
  color: #9B9B9B !important;
}
</style>
